import styled from 'styled-components'
import { vars } from '@machobear/design-system/css'

import { colors } from '@/styles'
import { Label } from '@/components/text'

export const MultiOptionList = styled.div`
  display: flex;
  border-radius: 4px;

  > :not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  > :not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }

  ${props =>
    props.disabled &&
    `
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  `};
`

const ItemWrapper = styled.button`
  border-radius: 4px;
  flex: 1;
  color: ${props =>
    props.isSelected
      ? vars.foregroundColor.white
      : vars.foregroundColor.neutral};
  background: ${props => (props.isSelected ? colors.secondary : 'none')};
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 16px 12px;
  border: 1px solid ${vars.borderColor.field};
`

export const MultiOptionItem = ({ id, label, onClick, selected }) => {
  return (
    <ItemWrapper
      type="button"
      onClick={() => onClick(id)}
      isSelected={selected}
    >
      <Label fontSize="14px" type="small">
        {label}
      </Label>
    </ItemWrapper>
  )
}
